/**
 * activityLogService.js
 * Axios service for the User Activity Log admin API.
 * All calls require the user to be authenticated as admin.
 */

import api from './axiosInstance';

/**
 * Fetch paginated activity logs with optional filters.
 * @param {object} params - { userId, action, status, email, startDate, endDate, page, limit }
 */
export const getActivityLogs = (params) =>
  api.get('/admin/activity-logs', { params });

/**
 * Fetch aggregated stats (today / week / month counts + top active users).
 */
export const getActivityStats = () =>
  api.get('/admin/activity-logs/stats');

/**
 * Fetch all filtered logs for CSV export (up to 10,000 rows).
 * @param {object} params - same filter params as getActivityLogs
 */
export const exportActivityLogs = (params) =>
  api.get('/admin/activity-logs/export', { params });

/**
 * Manually delete logs older than `days` days.
 * @param {number} days - number of days to keep (default 90)
 */
export const cleanupOldLogs = (days = 90) =>
  api.delete('/admin/activity-logs/cleanup', { params: { days } });
